import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from 'lucide-react';
import { cn } from '../../lib/utils';
import { SpecraInput } from '../specra/ensigns';
/**
 * PageToolbar provides a consistent toolbar layout with search, filters, and actions.
 * Uses compound component pattern for flexibility.
 *
 * @example
 * <PageToolbar>
 *   <PageToolbar.Search value={search} onChange={setSearch} placeholder="Search..." />
 *   <PageToolbar.Filters>
 *     <PageFilterLink active={filter === 'active'} count={5}>Active</PageFilterLink>
 *   </PageToolbar.Filters>
 *   <PageToolbar.Spacer />
 *   <PageToolbar.Actions>
 *     <Button><Plus className="w-4 h-4 mr-2" />New Item</Button>
 *   </PageToolbar.Actions>
 * </PageToolbar>
 */ function PageToolbarRoot({ children, className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('flex items-center gap-3 mb-6', className),
        children: children
    });
}
function PageToolbarSearch({ value, onChange, placeholder = 'Search...', className, dataTestid }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('relative max-w-sm', className),
        children: [
            /*#__PURE__*/ _jsx(Search, {
                className: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
            }),
            /*#__PURE__*/ _jsx(SpecraInput, {
                type: "text",
                placeholder: placeholder,
                value: value,
                onChange: (e)=>onChange(e.target.value),
                className: "pl-9 h-9",
                "data-testid": dataTestid
            })
        ]
    });
}
function PageToolbarFilters({ children, className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('flex items-center gap-4 text-sm', className),
        children: children
    });
}
function PageToolbarSpacer({ className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('flex-1', className)
    });
}
function PageToolbarActions({ children, className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('flex items-center gap-2', className),
        children: children
    });
}
export const PageToolbar = Object.assign(PageToolbarRoot, {
    Search: PageToolbarSearch,
    Filters: PageToolbarFilters,
    Spacer: PageToolbarSpacer,
    Actions: PageToolbarActions
});
